import * as React from 'react';

import { enumCustomAttributeEntityType } from '@rematter/frontend-lib-api-client';
import { ContentSection } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';
import { PurchaseOrderRecord } from '../../types/purchaseOrder';
import { LabeledText } from '../salesOrders/LabeledText';

import { CustomAttributeRecord } from '~/shared/components/custom-attributes/types';
import { useCustomAttributeDefinitionsQuery } from '~/shared/graphql/queries/useCustomAttributeDefinitionsQuery';

type Props = {
  purchaseOrder: PurchaseOrderRecord;
};

export const PurchaseOrderTabSupplierSectionCustomAttributes: React.FC<
  Props
> = ({ purchaseOrder }) => {
  const t = useTranslations();

  const { data: customAttributeDefinitions, isLoading } =
    useCustomAttributeDefinitionsQuery({
      entityType: enumCustomAttributeEntityType.CRMAccount,
    });

  const customAttributeValues = purchaseOrder.account?.customAttributes ?? {};

  if (isLoading) {
    return (
      <ContentSection
        variant="panel"
        title={t.purchaseOrderDetail.supplier.customAttributes.title}
      >
        <div className="flex flex-col items-center justify-center py-4">
          <div className="animate-pulse">
            <div className="h-4 w-24 rounded bg-neutral/20"></div>
          </div>
        </div>
      </ContentSection>
    );
  }

  if (!customAttributeDefinitions || customAttributeDefinitions.length === 0) {
    return null;
  }

  return (
    <ContentSection
      variant="panel"
      className="@PurchaseOrderTabSupplierSectionCustomAttributes"
      title={t.purchaseOrderDetail.supplier.customAttributes.title}
    >
      <div className="mt-4 grid grid-cols-3 gap-4">
        {customAttributeDefinitions.map((attribute: CustomAttributeRecord) => (
          <div key={attribute.id}>
            <LabeledText
              label={attribute.name}
              text={String(customAttributeValues[attribute.name] ?? '-')}
            />
          </div>
        ))}
      </div>
    </ContentSection>
  );
};
